<template>
	<v-card class="elevation-0 attendees-page attendees-page-container pt-7">
		<div class="d-flex">
			<v-skeleton-loader
				v-if="isLoading"
				v-bind="attrs"
				width="600"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
				<div class="mb-4">
					<router-link
						:to="{ name: 'event-by-id', params: { id: this.$route.params.id } }"
						class="d-flex text-decoration-none"
					>
						<v-icon small class="mr-1"> mdi-arrow-left-circle</v-icon>
						<div class="event-card__link">Back</div>
					</router-link>
				</div>

				<div class="attendees-page__title">Attendees</div>

				<div v-for="(attend, index) in attendees" :key="index">
					<AttendCard :user="attend "/>
				</div>

				<div
					class="d-flex my-9 justify-center home-page__pagination"
					v-if="!isLoading && attendees.length > 0"
				>
					<v-pagination
						color="#F2F2F2"
						:total-visible="10"
						circle
						v-model="filters.page"
						@input="(e) => onPageChange(e)"
						:length="+this.pageCountAttendees"
					></v-pagination>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AttendCard from '@/components/Event/AttendCard'

export default {
	name: 'AttendeesPage',
	components: {
    AttendCard,
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent']),

		onPageChange(page) {
			const params = {
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getAttendees(queryString)
		},

		formatFilters(filters) {
			const { page } = filters

			let queryString = `&event_id=${this.$route.params.id}&page=${page}&filter=event`

			return queryString
		},

		async getAttendees(additionalQueryParams = '') {
			await this.getAttendeesEvent(additionalQueryParams)
		},
	},

	created() {
		if (this.$route.params.id !== undefined) {
			this.getAttendeesEvent(`&event_id=${this.$route.params.id}&filter=event`)
		}
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
		}
	},
}
</script>

<style lang="scss">
.attendees-page {
	background: #f1f1f1 !important;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		margin-bottom: 10px;
	}
}

@media screen and (min-width: 1200px) {
	.attendees-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.attendees-page-container {
		max-width: 600px;
	}
}
</style>
